import { render, staticRenderFns } from "./summarize-modal.vue?vue&type=template&id=55688720&scoped=true"
import script from "./summarize-modal.vue?vue&type=script&lang=js"
export * from "./summarize-modal.vue?vue&type=script&lang=js"
import style0 from "./summarize-modal.vue?vue&type=style&index=0&id=55688720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55688720",
  null
  
)

export default component.exports